import { trpc } from '@/shared/api';

/** 메일 링크의 토큰으로 이메일 변경을 확정하는 뮤테이션. */
export const useConfirmEmailChange = () => trpc.auth.confirmEmailChange.useMutation();
